module.exports = __webpack_public_path__ + "img/trip-icon_innovador.23dde3b8.svg";